// IMPORTS

import { SeedInterface } from './interfaces';

import wheat from '../images/crops/wheat.png';
import potato from '../images/crops/potato.png';
import tomato from '../images/crops/tomato.png';
import grass from '../images/crops/grass.png';
import cabbage from '../images/crops/cabbage.png';
import beet from '../images/crops/beet.png';
import carrot from '../images/crops/carrot.png';
import corn from '../images/crops/corn.png';
import strawberry from '../images/crops/strawberry.png';
import onion from '../images/crops/onion.png';


// DATA


const seeds: SeedInterface = {
  Wheat: {
    seedIcon: wheat,
    seedPrice: 1,
    levelNeeded: 1
  },

  Potato: {
    seedIcon: potato,
    seedPrice: 1,
    levelNeeded: 1
  },

  Tomato: {
    seedIcon: tomato,
    seedPrice: 1,
    levelNeeded: 1
  },

  Grass: {
    seedIcon: grass,
    seedPrice: 1,
    levelNeeded: 1
  },

  Cabbage: {
    seedIcon: cabbage,
    seedPrice: 1,
    levelNeeded: 1
  },

  Beet: {
    seedIcon: beet,
    seedPrice: 1,
    levelNeeded: 1
  },

  Carrot: {
    seedIcon: carrot,
    seedPrice: 1,
    levelNeeded: 1
  },

  Corn: {
    seedIcon: corn,
    seedPrice: 1,
    levelNeeded: 1
  },

  Strawberry: {
    seedIcon: strawberry,
    seedPrice: 1,
    levelNeeded: 1
  },

  Onion: {
    seedIcon: onion,
    seedPrice: 1,
    levelNeeded: 1
  }
};


// EXPORTS


export default seeds;